import { combineReducers } from "redux";
import * as types from "./types";
import { buildKey } from "./utils";

const defaultSearchState = {
  counts: {},
  content: {}
};

const countsReducer = (state = defaultSearchState, action) => {
  const { type, isbn, query } = action;
  const key = buildKey(query, isbn);
  switch (type) {
    case types.COUNTS_SEARCH_REQUEST:
      if (state[key]) {
        return {
          ...state,
          [key]: {
            searchComplete: false,
            isSearching: true,
            ...state[key],
            [action.page]: { loading: true, results: [] }
          }
        };
      } else {
        return {
          ...state,
          [key]: {
            ...state[key],
            searchComplete: true,
            isSearching: true,
            pages: {
              ...(state[key] ? state[key].pages : {}),
              [action.page]: { loading: true, results: [], pages: {} }
            }
          }
        };
      }

    case types.COUNTS_SEARCH_SUCCESS:
      return {
        ...state,
        [key]: {
          ...state[key],
          isSearching: false,
          totalPages: action.pages,
          pages: {
            ...state[key].pages,
            [action.page]: { loading: false, results: action.results }
          }
        }
      };

    default:
      return state;
  }
};

const contentReducer = (state = {}, action) => {
  switch (action.type) {
    case types.SEARCH_BOOK_CONTENT_REQUEST:
      return {
        ...state,
        [action.isbn]: {
          isSearching: true,
          query: action.query,
          searchComplete: false
        }
      };
    case types.SEARCH_BOOK_CONTENT_SUCCESS:
      return {
        ...state,
        [action.isbn]: {
          searchComplete: true,
          isSearching: false,
          results: action.results,
          query: action.query,
          successTime: new Date().valueOf()
        }
      };
    case types.SEARCH_BOOK_CONTENT_FAILURE:
      return state;
    default:
      return state;
  }
};

const metadataReducer = (state = {}, action) => {
  switch (action.type) {
    case types.SEARCH_BOOK_METADATA_REQUEST:
      return {
        ...state,
        isSearching: true,
        query: action.query,
        results: []
      };
    case types.SEARCH_BOOK_METADATA_SUCCESS:
      return {
        ...state,
        query: action.query,
        results: [
          ...state.results,
          ...action.results.map(result => {
            if (action.source === types.LICENSE_SOURCE) {
              return { isbn: result.isbn, source: action.source };
            } else if (action.source === types.BRIDGE_SOURCE) {
              return { isbn: result.vbid, source: action.source };
            } else {
              return { isbn: result.isbn || result.vbid };
            }
          })
        ]
      };
    case types.SEARCH_BOOK_METADATA_COMPLETE:
      return {
        ...state,
        isSearching: false,
        query: action.query
      };
    case types.SEARCH_BOOK_METADATA_FAILURE:
      return {
        ...state,
        isSearching: false,
        results: []
      };
    default:
      return state;
  }
};

export default combineReducers({
  counts: countsReducer,
  content: contentReducer,
  metadata: metadataReducer
});
